import { IonIcon, IonImg, IonInput, IonItem, IonList, IonNote, IonText, IonButton as StyledButton } from "@ionic/react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

import { eye, eyeOff, eyeOffOutline, eyeOutline, person, personOutline } from "ionicons/icons";
//@ts-ignore
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { Usuario } from "../../interfaces";
import "./Login.css";

import dayjs from "dayjs";
import Footer from "../../components/Footer/Footer";
import { COLORS } from "../../constants/app";
import http from "../../hooks/httpAdapter";
import { useSession } from "../../hooks/SessionContext";
import useTituloPagina from "../../hooks/tituloPagina";

interface ContainerProps {}

//@ts-ignore
const Login: React.FC<ContainerProps> = ({}) => {
  const [blnVerPassword, setBlnVerPassword] = useState(false);
  const [usuario, setUsuario] = useState({
    usuario: "",
    password: "",
    token: "",
  });
  const [errorUsuario, setErrorUsuario] = useState(false);
  const [errorPassword, setErrorPassword] = useState(false);
  const [msjErrorPassword, setMsjErrorPassword] = useState("");
  const [registrarPaciente, setRegistrarPaciente] = useState(false);
  const { hcUL, cargandoSession, setHcUL, setSesionInvalida, setAgendaCargada, mostrarNotificacion } = useSession();

  useTituloPagina();
  const history = useHistory();

  const handleChangeVisibilityOfPassword = () => {
    setBlnVerPassword(!blnVerPassword);
  };

  useEffect(() => {
    if (cargandoSession === false) {
      setHcUL(null);
      setAgendaCargada(null);
    }

    if (history.location?.state) {
      if (
        //@ts-ignore
        history.location.state?.motivoRedireccion &&
        //@ts-ignore
        history.location.state?.motivoRedireccion === 401
      )
        mostrarNotificacion(true, "Su sesion existente ha espirado, por favor relogueese", COLORS.ERROR);
    }
  }, [cargandoSession]);

  const login = async (usuario: string, password: string) => {
    try {
      const response = await http()
        .post(`Usuarios/Login`, {
          nombreUsuario: usuario,
          password: password,
        })

        .catch((e) => {
          console.log(e);
          if (e.response && e.response.status === 404) {
            //history.push("/", { motivoRedireccion: "401" }); // Redirección en caso de error 401

            setMsjErrorPassword(e.response.data.message);
            return null;
          } else {
            console.error(e);
            return null;
          }
        });
      return response.token;
    } catch (error: any) {
      setErrorPassword(true);
      setMsjErrorPassword("Usuario o Password incorrecto");
      mostrarNotificacion(true, "Error: " + error.response, COLORS.ERROR);
    }
  };

  const obtenerPrestador = async (token: string, documento: string) => {
    let prestador: Usuario;
    try {
      const config = {
        headers: { Authorization: `Bearer ${token}` },
      };
      const response = await http()
        .get(`Usuarios?usuario=${documento}`, config)
        .catch((e) => {
          if (e.response && e.response.status === 401) {
            history.push("/", { motivoRedireccion: "401" }); // Redirección en caso de error 401
          } else {
            console.error(e);
          }
        });

      if (!response || response.length === 0) {
        throw new Error("No se encontraron datos para el usuario");
      }

      const data = response[0];

      prestador = {
        usuario: usuario.usuario,
        password: usuario.password,
        token: token,
        codigo: data.codigo,
        rol: data.rol,
        nombreUsuario: data.nombreUsuario,
        nombreCompleto: data.nombreCompleto,
        prestadorNom: data.prestadorNom,
        prestadorCod: data.prestadorCod,
        especialidadNom: data.especialidadNom,
        prestadores: data.prestadores,
        fechaSesion: dayjs().format("YYYY-MM-DD HH:mm:ss"),
      };

      return prestador;
    } catch (error: any) {
      console.error("❌ Error en petición obtenerPrestador", error);
      mostrarNotificacion(true, "Se produjo un error al intentar consultar los datos del prestador", COLORS.ERROR);
    }
  };

  const handleClickLogin = async () => {
    if (usuario.usuario !== "" && usuario.password !== "") {
      const token = await login(usuario.usuario, usuario.password);
      if (token) {
        const prestador = await obtenerPrestador(token, usuario.usuario);
        if (prestador) {
          mostrarNotificacion(true, "Sesión iniciada correctamente", COLORS.SUCCESS);
          setHcUL(prestador);
          setSesionInvalida(false);
          history.push("/portal/");
        }
      }
    } else {
      if (usuario.usuario !== "") {
        setErrorUsuario(true);
        setMsjErrorPassword("Debe ingresar su usuario");
      }
      if (usuario.password !== "") {
        setErrorPassword(true);
        setMsjErrorPassword("Debe ingresar su contraseña");
      }
    }
  };

  const handleClickSubmit = () => {
    handleClickLogin();
  };

  const handleChangeUsuario = (e: any) => {
    const value = e.target.value;
    setUsuario({ usuario: value, password: usuario.password, token: "" });
  };

  const handleChangePassword = (e: any) => {
    const value = e.target.value;
    setUsuario({ usuario: usuario.usuario, password: value, token: "" });
  };

  const handleCloseModalRegistrarPaciente = () => {
    setRegistrarPaciente(false);
  };

  return (
    <Dialog
      open={true}
      maxWidth="sm"
      fullWidth={false}
      PaperProps={{
        component: "form",
        onSubmit: (event: React.FormEvent<HTMLFormElement>) => {
          event.preventDefault();
        },
        sx: {
          width: 400,
          maxWidth: "90vw",
          padding: 0.5,
          borderRadius: 2,
          minHeight: "auto",
        },
      }}
    >
      <DialogTitle
        style={{
          textAlign: "center",
          paddingBottom: "8px",
          paddingTop: "12px",
        }}
      >
        <IonImg src="assets/icon/logo.jpg" style={{ width: "40%", margin: "0 auto", marginBottom: "4px" }} />
        <h3 style={{ margin: "8px 0 4px 0", fontWeight: "400" }}>Historias Clínicas de Pacientes</h3>
        <p style={{ margin: "0 0 8px 0", fontSize: "1rem" }}>Inicio de Sesión</p>
      </DialogTitle>
      <DialogContent style={{ paddingTop: "0px", paddingBottom: "12px" }}>
        <IonList>
          <IonItem lines="none">
            <IonInput
              fill="solid"
              aria-label="Usuario"
              label="Usuario"
              labelPlacement="fixed"
              value={usuario.usuario}
              onKeyUp={handleChangeUsuario}
              autofocus
              type="text"
              style={{ paddingStart: "2px" }}
            />
            <IonIcon aria-hidden="true" slot="end" ios={personOutline} md={person} />
          </IonItem>
          <IonItem lines="none" className={`${!errorPassword && "ion-valid"}`}>
            <IonInput
              fill="solid"
              aria-label="Contraseña"
              label="Contraseña"
              labelPlacement="fixed"
              value={usuario.password}
              onKeyUp={handleChangePassword}
              type={blnVerPassword ? "text" : "password"}
              className="passwordInput"
            />
            <IonIcon
              aria-hidden="true"
              slot="end"
              ios={blnVerPassword ? eyeOutline : eyeOffOutline}
              md={blnVerPassword ? eye : eyeOff}
              onClick={handleChangeVisibilityOfPassword}
            />
            {errorPassword && (
              <IonNote slot="error">
                <IonText color={"danger"}>
                  <small>{msjErrorPassword}</small>
                </IonText>
              </IonNote>
            )}
          </IonItem>

          <StyledButton
            //@ts-ignore
            lines="none"
            size="large"
            className="verde justify-content-center"
            onClick={handleClickSubmit}
          >
            Ingresar
          </StyledButton>
          <IonItem lines="none" style={{ marginTop: "8px" }}>
            <IonText style={{ fontSize: "0.85rem", textAlign: "center", width: "100%" }}>
              <a href="/privacidad" target="_blank" rel="noopener noreferrer" style={{ color: "var(--ion-color-primary)", textDecoration: "none" }}>
                Política de Privacidad
              </a>
            </IonText>
          </IonItem>
        </IonList>
      </DialogContent>
      <Footer />
    </Dialog>
  );
};

export default Login;
